import { jsx as d } from "react/jsx-runtime";
import { c as I } from "react/compiler-runtime";
import { copyToClipBoard as z } from "../../../utilities/index.js";
import { useState as S } from "react";
import { CheckCircleOutline as k, ContentCopy as w } from "@mui/icons-material";
const h = {
  xs: "0.5rem",
  sm: "0.75rem",
  md: "1rem",
  lg: "1.25rem",
  xl: "1.5rem"
};
function B(u) {
  const o = I(11), {
    color: a,
    text: i,
    size: f
  } = u, t = a === void 0 ? "#226a58" : a, y = f === void 0 ? "sm" : f, [x, C] = S(!1);
  let r;
  o[0] !== i ? (r = async () => {
    try {
      await z(i), C(!0), setTimeout(() => C(!1), 2e3);
    } catch (c) {
      console.error("Failed to copy ", c);
    }
  }, o[0] = i, o[1] = r) : r = o[1];
  const l = r;
  if (x) {
    const c = h[y];
    let n;
    return o[2] !== t || o[3] !== c ? (n = /* @__PURE__ */ d(k, { sx: {
      color: t,
      fontSize: c,
      ...p.endIcon
    } }), o[2] = t, o[3] = c, o[4] = n) : n = o[4], n;
  }
  const m = h[y];
  let e;
  o[5] !== t || o[6] !== m ? (e = {
    color: t,
    fontSize: m,
    ...p.endIcon,
    ...p.actionIcon
  }, o[5] = t, o[6] = m, o[7] = e) : e = o[7];
  let s;
  return o[8] !== l || o[9] !== e ? (s = /* @__PURE__ */ d(w, { sx: e, onClick: l }), o[8] = l, o[9] = e, o[10] = s) : s = o[10], s;
}
const p = {
  endIcon: {
    ml: 2,
    opacity: 0.5
  },
  actionIcon: {
    opacity: 1,
    cursor: "pointer"
  }
};
export {
  B as CopyComponent
};
